module.exports = __webpack_public_path__ + "static/img/1_1_1.7f4285fe.jpg";